
export class BusyMixin {
    busy: Promise<any> = null;
}

function BusyMixin_tsickle_Closure_declarations() {
/** @type {?} */
BusyMixin.prototype.busy;
}

export class PrefixMixin {
    prefix = '';
}

function PrefixMixin_tsickle_Closure_declarations() {
/** @type {?} */
PrefixMixin.prototype.prefix;
}

